var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.init)?_c('div',{staticClass:"mOrderListFail"},[_c('pull',{attrs:{"pull":_vm.pull,"page":_vm.page},on:{"getList":_vm.getList}},[(!_vm.orderList.length)?_c('NoData'):_c('MDataList',{attrs:{"orderList":_vm.orderList}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }